import { BannerHeader } from '@components/branding/banner-header';
import { createConfigurationValuesService } from '@services/factories';
import * as React from 'react';

const BrandedBannerHeader = (props: { children?: React.ReactNode; offset?: boolean }) => {
    const configurationValuesService = React.useRef(createConfigurationValuesService()).current;
    const imageSource = configurationValuesService.bannerHeaderUrl;
    
    return (
        <BannerHeader imageSrc={imageSource} offset={props.offset}>{props.children}</BannerHeader>
    );
};

export default BrandedBannerHeader;



// WEBPACK FOOTER //
// ./src/containers/branded-banner-header/index.tsx